import { EnvironmentProviders, inject, Provider } from '@angular/core';
import { provideSearchModule, provideSoftAppsModuleInfo } from '@softapps/core';
import { getModuleGroupById, registerApplication } from '@softline/application';
import { ConnectionHttpService } from '@softline/core';
import { FieldOkService } from '@softline/dynamic';
import { catchError, map, Observable, of, shareReplay } from 'rxjs';
import { default as de } from '../i18n/de.json';
import { LieferantenstammSearchResultComponent } from './search/lieferantenstamm-search-result.component';
import { SupplierIdService } from './services/supplier-id.service';

export const lieferantenstammProviders: Array<Provider | EnvironmentProviders> = [
  registerApplication({
    name: 'lieferantenstamm',
    title: 'Lieferantenstamm',
    icon: 'fa-regular fa-truck',
    route: 'lieferantenstamm',
    translations: { de },
    group: getModuleGroupById(1), // Stammdaten
  }),
  provideSoftAppsModuleInfo('Lieferantenstamm', {
    key: 'lieferantenstamm',
    library: '@softapps/lieferantenstamm',
    description: 'Lieferantenstamm mit Detailansicht und Produktgruppen.',
  }),
  SupplierIdService,
  provideSearchModule<any>({
    url: '/lieferantenstamm',
    category: 'Lieferanten',
    icon: 'fa-regular fa-truck',
    component: LieferantenstammSearchResultComponent,
    factory: () => {
      const fieldOkService = new FieldOkService(inject(ConnectionHttpService), 'ktostamm.lieferant');

      let lastTerm = '';
      let lastResult$: Observable<any[]> = of([]);

      return {
        results(term: string | null): Observable<any[]> {
          const normalized = term?.trim() ?? '';
          if (normalized.length < 3) return of([]);
          if (normalized === lastTerm) return lastResult$;

          lastTerm = normalized;
          lastResult$ = fieldOkService.query({
            filter: normalized,
            multiValued: false,
            parameters: {} as any,
            maxAbfrageResults: 20,
          }).pipe(
            map((response: any) => {
              if (Array.isArray(response)) return response.slice(0, 20);
              if (response?.data) return Object.values(response.data).slice(0, 20);
              return [];
            }),
            catchError(() => of([])),
            shareReplay(1)
          );
          return lastResult$;
        },
      };
    },
  }),
];
